import React from 'react';
import { Box, Card, Grid, Typography } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import RoomIcon from '@mui/icons-material/Room';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import LinkIcon from '@mui/icons-material/Link';
interface VCardProps {
  name: string;
  tenantId?: string;
  tenantName: string;
  department: string;
  title: string;
  phone: string;
  logo: string;
  address: string;
  avatar: string;
  email?: string;
  status?: string;
  website?: string;
  orientation?: 'left' | 'right';
}
const VCard = ((props: VCardProps) => {
  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down('sm'));

  const {
    avatar, name,
    department, title,
    phone, email = '您的邮箱',
    logo = '/images/logo.png',
    tenantName, address, website
  } = props;
  console.log('logo========', logo);
  const dense = ( isXsOrSm );
  const orientation = 'left';
  const defaultAvatar =  '/images/honeycomb.svg';

  // const imageURL = status === '未认证' ? '/images/n_certified.png' : '/images/certified.png';
  return (
    <Card
      style={{
        position: 'relative',
        height: 0,
        paddingBottom: '60%',
        width: '100%',
        borderRadius: 16
      }}
      elevation={4}
    >
      <Grid container style={{ height: '100%', position: 'absolute' }}>
        <Grid item xs={5} style={{
          height: '100%',
          backgroundImage: `url(${avatar || defaultAvatar})`,
          backgroundSize: avatar ? 'cover' : 'auto',
          backgroundPosition: 'center',
          clipPath: 'polygon(0% 0%, 100% 0%, 65% 100%, 0% 100%)',
        }} />
        <Grid item xs={7}
          style={{
            height: '100%',
            padding: dense ? '8px' : '16px',
            display: 'flex', flexDirection: 'column'
          }}
        >
          <Box display='flex' alignItems='center' flexDirection='row' justifyContent='flex-end' mb={dense ? 0 : 1.5}>
            <Box height={dense ? '36px' : '48px'} width={dense ? '56px' : '72px'}
              mr={1}
              style={{ background: `url(${logo}) no-repeat left`, backgroundSize: 'contain' }}
            />
          </Box>
          <Box sx={{textAlign:orientation}}>
            <Typography variant='h5' >
              {dense ? name : <strong>{name}</strong>}
            </Typography>
            <Typography variant='overline' style={{lineHeight:'1em', paddingTop:'8px',textAlign:orientation}}>
              {[department, title].filter(i => i).join(' / ')}
            </Typography>
          </Box>
          <Box flex={1} />
          <Typography  style={{fontSize: dense ? 'x-small' : 'small',textAlign:orientation}}>{tenantName}</Typography>
          {phone && <Typography gutterBottom={!dense} style={{ fontSize: dense ? 'x-small' : 'small', fontWeight: 400 ,textAlign:orientation,display:'flex',flexDirection:orientation==='right'?'row-reverse':'row',alignItems:'center'}} >
            <PhoneIcon style={{ fontSize: 'smaller', marginRight: orientation==='right'?'0px':'8px',marginLeft: orientation==='right'?'8px':'0px' }} />
            {phone}
          </Typography>}
          {email && <Typography gutterBottom={!dense} style={{ fontSize: dense ? 'x-small' : 'small', fontWeight: 400,textAlign:orientation,display:'flex',flexDirection:orientation==='right'?'row-reverse':'row',alignItems:'center' }} >
            <EmailIcon style={{ fontSize: 'smaller', marginRight: orientation==='right'?'0px':'8px',marginLeft: orientation==='right'?'8px':'0px' }} />
            {email}
          </Typography>}
          {address && <Typography gutterBottom={!dense} style={{ fontSize: dense ? 'x-small' : 'small', fontWeight: 400 ,textAlign:orientation,display:'flex',flexDirection:orientation==='right'?'row-reverse':'row',alignItems:'center' }} >
            <RoomIcon style={{ fontSize: 'smaller', marginRight: orientation==='right'?'0px':'8px',marginLeft: orientation==='right'?'8px':'0px' }} />
            {address}
          </Typography>}
          {website && <Typography onClick={() => {
            window.open(website.startsWith('http') ? website : `https://${website}`, '_blank');
          }} gutterBottom={!dense} style={{cursor:'pointer', fontSize: dense ? 'x-small' : 'small', fontWeight: 400,textAlign:orientation, display:'flex', flexDirection:orientation==='right'?'row-reverse':'row',alignItems:'center' }} >
            <LinkIcon style={{ fontSize: 'smaller', marginRight: orientation==='right'?'0px':'8px',marginLeft: orientation==='right'?'8px':'0px' }} />
            {website}
          </Typography>}
        </Grid>
      </Grid>
    </Card>
  );
});
export default VCard;
